module.exports = __webpack_public_path__ + "static/media/icon-file-ppt.26956253.svg";